import React, { useEffect, useMemo } from 'react';
import queryString from 'query-string';
import { LoginHeader } from "../../components/Header";
import { LeftSidebar } from "./LeftSidebar";
import { RightSidebar } from "./RightSidebar";
import { ModalWrapper } from "./modalWrapper";
import { LoginModalFlowProvider } from "../../context/LoginModalFlowContext";
import { createCookie } from '../../../utils/cookieUtils';
import { LeftSidebarNoRecaptcha } from './LeftSidebarNoRecaptcha';
import { useLDVariants } from '../../context/LaunchDarklyProvider';

export const LoginV2 = () => {
  const ldVariants = useLDVariants();
  const urlParams = useMemo(() => queryString.parse(window.location.search), []);
  useEffect(() => {
    if (urlParams.con_id) {
      createCookie({
        name: '_convid',
        value: urlParams.con_id,
      });
    }

    document.cookie = "_convid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.smiles.com.br; path=/;";
    document.cookie = "_userid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.smiles.com.br; path=/;";
    document.cookie = "_loginEntryChannel=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.smiles.com.br; path=/;";
    document.cookie = "_entryPhone=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.smiles.com.br; path=/;";
    document.cookie = "_subEnv=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.smiles.com.br; path=/;";
    if (window.location.search.includes("con_id") && window.location.search.includes("user_id") && window.location.search.includes("login_entry_channel") && window.location.search.includes("entry_phone") && window.location.search.includes("sub_env")) {
      const urlQueryParam = queryString.parse(window.location.search.replaceAll('%253D', '=').replaceAll('%2526', '&').replaceAll('%3D', '&'));
      document.cookie = `_convid=${urlQueryParam.con_id};domain=.smiles.com.br;path=/`;
      document.cookie = `_userid=${urlQueryParam.user_id};domain=.smiles.com.br;path=/`;
      document.cookie = `_loginEntryChannel=${urlQueryParam.login_entry_channel};domain=.smiles.com.br;path=/`;
      document.cookie = `_entryPhone=${urlQueryParam.entry_phone};domain=.smiles.com.br;path=/`;
      document.cookie = `_subEnv=${urlQueryParam.sub_env};domain=.smiles.com.br;path=/`;
    }
  }, []);


  return (
    <div className="auth0-container-v2">
      <LoginModalFlowProvider>
        <LoginHeader />
        <div className="login-content">
          {ldVariants.flags.loginNoRecaptcha ? <LeftSidebarNoRecaptcha /> : <LeftSidebar />}
          <RightSidebar />
        </div>
        <ModalWrapper />
      </LoginModalFlowProvider>
    </div>
  );
};

